import React from 'react';

import { Modal, BlockStack, Text } from '@shopify/polaris';

const DeleteUserDialog = ({ user, displayDeleteUserDialog, setDisplayDeleteUserDialog, deleteUser, setSubmitted }) => {
  const submit = () => {
    deleteUser(user.email);
    setSubmitted(true);
    setDisplayDeleteUserDialog(false);

    close();
  }


  const close = () => {
    setDisplayDeleteUserDialog(false);
  }

  return(
    <Modal
      open={displayDeleteUserDialog}
      onClose={() => close()}
      title="Delete User"
      primaryAction={{
        content: 'Delete User',
        destructive: true,
        onAction: () => submit(),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => close()
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="200">
          <Text as="h3" variant="headingSm">User Details</Text>

          <Text as="p">
            {user.loginName}
          </Text>

          <Text as="p">
            {user.email}
          </Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

export default DeleteUserDialog;
